import currency from 'currency.js';
import { handleNumber } from './util';
import { PROCESSING_FEE_RATE } from '../config/processingFeeConfig';

/**
 * Everything the retailer frontend knows about the processing fee.
 *
 * All three entry points are plain functions on purpose — do not turn them into
 * a hook. UnpaidOrders/Pages/PaymentPanel/PaymentOptions keeps the selected
 * payment method in component-local useState and never puts it in redux, so
 * that flow cannot consume a useSelector-based hook.
 */

const getRate = () => PROCESSING_FEE_RATE;

/**
 * Fee on a single amount. Returns a currency object, not a number, so the
 * caller chooses the representation: .toString() pads to two decimals ("1.10"),
 * .value does not (1.1).
 */
const fromAmount = (amount) => currency(amount).multiply(getRate());

const fromOrders = (orders, isFormated = true, pass) => {
  let processingFee = 0;
  orders.forEach((order) => {
    if (order.flag === 'success' || order.flag === 'info' || pass) {
      if (order.status !== 'unpaid') {
        // For paid orders use the order-level field returned by the API.
        // Item-level processing_fee may not be populated by all API paths.
        // Number() kept as-is. The reason given elsewhere for it — "retailer-api
        // returns this column as a string via MySqlDecimalType" — does not hold:
        // that type's convertToJSValue is parseFloat() and returns a number
        // (dsz-app-core/src/database/custom_type.ts, checked 2026-09-10). It
        // stays because it costs nothing, not because that claim is true.
        processingFee += Number(order.processing_fee || 0);
      } else {
        // For unpaid orders: sum the entire base (items + surcharge) first, then
        // apply rate once to avoid intermediate rounding accumulation.
        let base = 0;
        order.items.forEach((item) => {
          base = currency(item.price)
            .add(item.shipping_fee)
            .multiply(item.qty)
            .add(base).value;
        });
        base = currency(base).add(order.postage_surcharge || 0).add(order.handling_fee || 0).add(order.pallet_fee || 0).value;
        processingFee = currency(base).multiply(getRate()).add(processingFee).value;
      }
    }
  });

  return isFormated ? handleNumber(processingFee, 2, true, '$') : processingFee;
};

const ProcessingFee = { getRate, fromAmount, fromOrders };

export default ProcessingFee;
